/* esm.sh - @tanstack/query-core@5.90.10 */
var O = class {
  constructor() {
    (this.listeners = new Set()), (this.subscribe = this.subscribe.bind(this));
  }
  subscribe(t) {
    return (
      this.listeners.add(t),
      this.onSubscribe(),
      () => {
        this.listeners.delete(t), this.onUnsubscribe();
      }
    );
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {}
  onUnsubscribe() {}
};
var qt = {
    setTimeout: (t, e) => setTimeout(t, e),
    clearTimeout: (t) => clearTimeout(t),
    setInterval: (t, e) => setInterval(t, e),
    clearInterval: (t) => clearInterval(t),
  },
  At = class {
    #e = qt;
    #t = !1;
    setTimeoutProvider(t) {
      this.#e = t;
    }
    setTimeout(t, e) {
      return this.#e.setTimeout(t, e);
    }
    clearTimeout(t) {
      this.#e.clearTimeout(t);
    }
    setInterval(t, e) {
      return this.#e.setInterval(t, e);
    }
    clearInterval(t) {
      this.#e.clearInterval(t);
    }
  },
  R = new At();
function pt(t) {
  setTimeout(t, 0);
}
var C = typeof window > "u" || "Deno" in globalThis;
function m() {}
function vt(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function L(t) {
  return typeof t == "number" && t >= 0 && t !== 1 / 0;
}
function W(t, e) {
  return Math.max(t + (e || 0) - Date.now(), 0);
}
function Q(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function S(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function J(t, e) {
  let {
    type: s = "all",
    exact: r,
    fetchStatus: i,
    predicate: n,
    queryKey: h,
    stale: a,
  } = t;
  if (h) {
    if (r) {
      if (e.queryHash !== H(h, e.options)) return !1;
    } else if (!q(e.queryKey, h)) return !1;
  }
  if (s !== "all") {
    let u = e.isActive();
    if ((s === "active" && !u) || (s === "inactive" && u)) return !1;
  }
  return !(
    (typeof a == "boolean" && e.isStale() !== a) ||
    (i && i !== e.state.fetchStatus) ||
    (n && !n(e))
  );
}
function Z(t, e) {
  let { exact: s, status: r, predicate: i, mutationKey: n } = t;
  if (n) {
    if (!e.options.mutationKey) return !1;
    if (s) {
      if (D(e.options.mutationKey) !== D(n)) return !1;
    } else if (!q(e.options.mutationKey, n)) return !1;
  }
  return !((r && e.state.status !== r) || (i && !i(e)));
}
function H(t, e) {
  return (e?.queryKeyHashFn || D)(t);
}
function D(t) {
  return JSON.stringify(t, (e, s) =>
    rt(s)
      ? Object.keys(s)
          .sort()
          .reduce((r, i) => ((r[i] = s[i]), r), {})
      : s
  );
}
function q(t, e) {
  return t === e
    ? !0
    : typeof t != typeof e
    ? !1
    : t && e && typeof t == "object" && typeof e == "object"
    ? Object.keys(e).every((s) => q(t[s], e[s]))
    : !1;
}
var It = Object.prototype.hasOwnProperty;
function _(t, e) {
  if (t === e) return t;
  let s = yt(t) && yt(e);
  if (!s && !(rt(t) && rt(e))) return e;
  let i = (s ? t : Object.keys(t)).length,
    n = s ? e : Object.keys(e),
    h = n.length,
    a = s ? new Array(h) : {},
    u = 0;
  for (let l = 0; l < h; l++) {
    let o = s ? l : n[l],
      p = t[o],
      c = e[o];
    if (p === c) {
      (a[o] = p), (s ? l < i : It.call(t, o)) && u++;
      continue;
    }
    if (
      p === null ||
      c === null ||
      typeof p != "object" ||
      typeof c != "object"
    ) {
      a[o] = c;
      continue;
    }
    let b = _(p, c);
    (a[o] = b), b === p && u++;
  }
  return i === h && u === i ? t : a;
}
function x(t, e) {
  if (!e || Object.keys(t).length !== Object.keys(e).length) return !1;
  for (let s in t) if (t[s] !== e[s]) return !1;
  return !0;
}
function yt(t) {
  return Array.isArray(t) && t.length === Object.keys(t).length;
}
function rt(t) {
  if (!mt(t)) return !1;
  let e = t.constructor;
  if (e === void 0) return !0;
  let s = e.prototype;
  return !(
    !mt(s) ||
    !s.hasOwnProperty("isPrototypeOf") ||
    Object.getPrototypeOf(t) !== Object.prototype
  );
}
function mt(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function gt(t) {
  return new Promise((e) => {
    R.setTimeout(e, t);
  });
}
function z(t, e, s) {
  return typeof s.structuralSharing == "function"
    ? s.structuralSharing(t, e)
    : s.structuralSharing !== !1
    ? _(t, e)
    : e;
}
function kt(t) {
  return t;
}
function X(t, e, s = 0) {
  let r = [...t, e];
  return s && r.length > s ? r.slice(1) : r;
}
function bt(t, e, s = 0) {
  let r = [e, ...t];
  return s && r.length > s ? r.slice(0, -1) : r;
}
var U = Symbol();
function Y(t, e) {
  return !t.queryFn && e?.initialPromise
    ? () => e.initialPromise
    : !t.queryFn || t.queryFn === U
    ? () => Promise.reject(new Error(`Missing queryFn: '${t.queryHash}'`))
    : t.queryFn;
}
function Ut(t, e) {
  return typeof t == "function" ? t(...e) : !!t;
}
var Kt = class extends O {
    #e;
    #t;
    #s;
    constructor() {
      super(),
        (this.#s = (t) => {
          if (!C && window.addEventListener) {
            let e = () => t();
            return (
              window.addEventListener("visibilitychange", e, !1),
              () => {
                window.removeEventListener("visibilitychange", e);
              }
            );
          }
        });
    }
    onSubscribe() {
      this.#t || this.setEventListener(this.#s);
    }
    onUnsubscribe() {
      this.hasListeners() || (this.#t?.(), (this.#t = void 0));
    }
    setEventListener(t) {
      (this.#s = t),
        this.#t?.(),
        (this.#t = t((e) => {
          typeof e == "boolean" ? this.setFocused(e) : this.onFocus();
        }));
    }
    setFocused(t) {
      this.#e !== t && ((this.#e = t), this.onFocus());
    }
    onFocus() {
      let t = this.isFocused();
      this.listeners.forEach((e) => {
        e(t);
      });
    }
    isFocused() {
      return typeof this.#e == "boolean"
        ? this.#e
        : globalThis.document?.visibilityState !== "hidden";
    }
  },
  A = new Kt();
function G() {
  let t,
    e,
    s = new Promise((i, n) => {
      (t = i), (e = n);
    });
  (s.status = "pending"), s.catch(() => {});
  function r(i) {
    Object.assign(s, i), delete s.resolve, delete s.reject;
  }
  return (
    (s.resolve = (i) => {
      r({ status: "fulfilled", value: i }), t(i);
    }),
    (s.reject = (i) => {
      r({ status: "rejected", reason: i }), e(i);
    }),
    s
  );
}
function Ot(t) {
  let e;
  if ((t.then((s) => ((e = s), s), m)?.catch(m), e !== void 0))
    return { data: e };
}
function St(t) {
  return t;
}
function jt(t) {
  return {
    mutationKey: t.options.mutationKey,
    state: t.state,
    ...(t.options.scope && { scope: t.options.scope }),
    ...(t.meta && { meta: t.meta }),
  };
}
function Nt(t, e, s) {
  let r = () => {
    let i = t.promise
      ?.then(e)
      .catch((n) =>
        s(n) ? Promise.reject(new Error("redacted")) : Promise.reject(n)
      );
    return i?.catch(m), i;
  };
  return {
    dehydratedAt: Date.now(),
    state: {
      ...t.state,
      ...(t.state.data !== void 0 && { data: e(t.state.data) }),
    },
    queryKey: t.queryKey,
    queryHash: t.queryHash,
    ...(t.state.status === "pending" && { promise: r() }),
    ...(t.meta && { meta: t.meta }),
  };
}
function Pt(t) {
  return t.state.isPaused;
}
function wt(t) {
  return t.state.status === "success";
}
function Lt(t) {
  return !0;
}
function Ht(t, e = {}) {
  let s =
      e.shouldDehydrateMutation ??
      t.getDefaultOptions().dehydrate?.shouldDehydrateMutation ??
      Pt,
    r = t
      .getMutationCache()
      .getAll()
      .flatMap((u) => (s(u) ? [jt(u)] : [])),
    i =
      e.shouldDehydrateQuery ??
      t.getDefaultOptions().dehydrate?.shouldDehydrateQuery ??
      wt,
    n =
      e.shouldRedactErrors ??
      t.getDefaultOptions().dehydrate?.shouldRedactErrors ??
      Lt,
    h = e.serializeData ?? t.getDefaultOptions().dehydrate?.serializeData ?? St,
    a = t
      .getQueryCache()
      .getAll()
      .flatMap((u) => (i(u) ? [Nt(u, h, n)] : []));
  return { mutations: r, queries: a };
}
function _t(t, e, s) {
  if (typeof e != "object" || e === null) return;
  let r = t.getMutationCache(),
    i = t.getQueryCache(),
    n =
      s?.defaultOptions?.deserializeData ??
      t.getDefaultOptions().hydrate?.deserializeData ??
      St,
    h = e.mutations || [],
    a = e.queries || [];
  h.forEach(({ state: u, ...l }) => {
    r.build(
      t,
      {
        ...t.getDefaultOptions().hydrate?.mutations,
        ...s?.defaultOptions?.mutations,
        ...l,
      },
      u
    );
  }),
    a.forEach(
      ({
        queryKey: u,
        state: l,
        queryHash: o,
        meta: p,
        promise: c,
        dehydratedAt: b,
      }) => {
        let v = c ? Ot(c) : void 0,
          f = l.data === void 0 ? v?.data : l.data,
          g = f === void 0 ? f : n(f),
          y = i.get(o),
          P = y?.state.status === "pending",
          M = y?.state.fetchStatus === "fetching";
        if (y) {
          let F = v && b !== void 0 && b > y.state.dataUpdatedAt;
          if (l.dataUpdatedAt > y.state.dataUpdatedAt || F) {
            let { fetchStatus: T, ...N } = l;
            y.setState({ ...N, data: g });
          }
        } else
          y = i.build(
            t,
            {
              ...t.getDefaultOptions().hydrate?.queries,
              ...s?.defaultOptions?.queries,
              queryKey: u,
              queryHash: o,
              meta: p,
            },
            {
              ...l,
              data: g,
              fetchStatus: "idle",
              status: g !== void 0 ? "success" : l.status,
            }
          );
        c &&
          !P &&
          !M &&
          (b === void 0 || b > y.state.dataUpdatedAt) &&
          y
            .fetch(void 0, { initialPromise: Promise.resolve(c).then(n) })
            .catch(m);
      }
    );
}
var Ct = pt;
function zt() {
  let t = [],
    e = 0,
    s = (a) => {
      a();
    },
    r = (a) => {
      a();
    },
    i = Ct,
    n = (a) => {
      e
        ? t.push(a)
        : i(() => {
            s(a);
          });
    },
    h = () => {
      let a = t;
      (t = []),
        a.length &&
          i(() => {
            r(() => {
              a.forEach((u) => {
                s(u);
              });
            });
          });
    };
  return {
    batch: (a) => {
      let u;
      e++;
      try {
        u = a();
      } finally {
        e--, e || h();
      }
      return u;
    },
    batchCalls:
      (a) =>
      (...u) => {
        n(() => {
          a(...u);
        });
      },
    schedule: n,
    setNotifyFunction: (a) => {
      s = a;
    },
    setBatchNotifyFunction: (a) => {
      r = a;
    },
    setScheduler: (a) => {
      i = a;
    },
  };
}
var d = zt();
var Gt = class extends O {
    #e = !0;
    #t;
    #s;
    constructor() {
      super(),
        (this.#s = (t) => {
          if (!C && window.addEventListener) {
            let e = () => t(!0),
              s = () => t(!1);
            return (
              window.addEventListener("online", e, !1),
              window.addEventListener("offline", s, !1),
              () => {
                window.removeEventListener("online", e),
                  window.removeEventListener("offline", s);
              }
            );
          }
        });
    }
    onSubscribe() {
      this.#t || this.setEventListener(this.#s);
    }
    onUnsubscribe() {
      this.hasListeners() || (this.#t?.(), (this.#t = void 0));
    }
    setEventListener(t) {
      (this.#s = t), this.#t?.(), (this.#t = t(this.setOnline.bind(this)));
    }
    setOnline(t) {
      this.#e !== t &&
        ((this.#e = t),
        this.listeners.forEach((s) => {
          s(t);
        }));
    }
    isOnline() {
      return this.#e;
    }
  },
  I = new Gt();
function Vt(t) {
  return Math.min(1e3 * 2 ** t, 3e4);
}
function it(t) {
  return (t ?? "online") === "online" ? I.isOnline() : !0;
}
var K = class extends Error {
  constructor(t) {
    super("CancelledError"),
      (this.revert = t?.revert),
      (this.silent = t?.silent);
  }
};
function Bt(t) {
  return t instanceof K;
}
function tt(t) {
  let e = !1,
    s = 0,
    r,
    i = G(),
    n = () => i.status !== "pending",
    h = (f) => {
      if (!n()) {
        let g = new K(f);
        c(g), t.onCancel?.(g);
      }
    },
    a = () => {
      e = !0;
    },
    u = () => {
      e = !1;
    },
    l = () =>
      A.isFocused() &&
      (t.networkMode === "always" || I.isOnline()) &&
      t.canRun(),
    o = () => it(t.networkMode) && t.canRun(),
    p = (f) => {
      n() || (r?.(), i.resolve(f));
    },
    c = (f) => {
      n() || (r?.(), i.reject(f));
    },
    b = () =>
      new Promise((f) => {
        (r = (g) => {
          (n() || l()) && f(g);
        }),
          t.onPause?.();
      }).then(() => {
        (r = void 0), n() || t.onContinue?.();
      }),
    v = () => {
      if (n()) return;
      let f,
        g = s === 0 ? t.initialPromise : void 0;
      try {
        f = g ?? t.fn();
      } catch (y) {
        f = Promise.reject(y);
      }
      Promise.resolve(f)
        .then(p)
        .catch((y) => {
          if (n()) return;
          let P = t.retry ?? (C ? 0 : 3),
            M = t.retryDelay ?? Vt,
            F = typeof M == "function" ? M(s, y) : M,
            T =
              P === !0 ||
              (typeof P == "number" && s < P) ||
              (typeof P == "function" && P(s, y));
          if (e || !T) {
            c(y);
            return;
          }
          s++,
            t.onFail?.(s, y),
            gt(F)
              .then(() => (l() ? void 0 : b()))
              .then(() => {
                e ? c(y) : v();
              });
        });
    };
  return {
    promise: i,
    status: () => i.status,
    cancel: h,
    continue: () => (r?.(), i),
    cancelRetry: a,
    continueRetry: u,
    canStart: o,
    start: () => (o() ? v() : b().then(v), i),
  };
}
var et = class {
  #e;
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(),
      L(this.gcTime) &&
        (this.#e = R.setTimeout(() => {
          this.optionalRemove();
        }, this.gcTime));
  }
  updateGcTime(t) {
    this.gcTime = Math.max(this.gcTime || 0, t ?? (C ? 1 / 0 : 300 * 1e3));
  }
  clearGcTimeout() {
    this.#e && (R.clearTimeout(this.#e), (this.#e = void 0));
  }
};
var nt = class extends et {
  #e;
  #t;
  #s;
  #i;
  #r;
  #n;
  #o;
  constructor(t) {
    super(),
      (this.#o = !1),
      (this.#n = t.defaultOptions),
      this.setOptions(t.options),
      (this.observers = []),
      (this.#i = t.client),
      (this.#s = this.#i.getQueryCache()),
      (this.queryKey = t.queryKey),
      (this.queryHash = t.queryHash),
      (this.#e = Rt(this.options)),
      (this.state = t.state ?? this.#e),
      this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  get promise() {
    return this.#r?.promise;
  }
  setOptions(t) {
    if (
      ((this.options = { ...this.#n, ...t }),
      this.updateGcTime(this.options.gcTime),
      this.state && this.state.data === void 0)
    ) {
      let e = Rt(this.options);
      e.data !== void 0 &&
        (this.setState(Mt(e.data, e.dataUpdatedAt)), (this.#e = e));
    }
  }
  optionalRemove() {
    !this.observers.length &&
      this.state.fetchStatus === "idle" &&
      this.#s.remove(this);
  }
  setData(t, e) {
    let s = z(this.state.data, t, this.options);
    return (
      this.#a({
        data: s,
        type: "success",
        dataUpdatedAt: e?.updatedAt,
        manual: e?.manual,
      }),
      s
    );
  }
  setState(t, e) {
    this.#a({ type: "setState", state: t, setStateOptions: e });
  }
  cancel(t) {
    let e = this.#r?.promise;
    return this.#r?.cancel(t), e ? e.then(m).catch(m) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({ silent: !0 });
  }
  reset() {
    this.destroy(), this.setState(this.#e);
  }
  isActive() {
    return this.observers.some((t) => S(t.options.enabled, this) !== !1);
  }
  isDisabled() {
    return this.getObserversCount() > 0
      ? !this.isActive()
      : this.options.queryFn === U ||
          this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
  }
  isStatic() {
    return this.getObserversCount() > 0
      ? this.observers.some((t) => Q(t.options.staleTime, this) === "static")
      : !1;
  }
  isStale() {
    return this.getObserversCount() > 0
      ? this.observers.some((t) => t.getCurrentResult().isStale)
      : this.state.data === void 0 || this.state.isInvalidated;
  }
  isStaleByTime(t = 0) {
    return this.state.data === void 0
      ? !0
      : t === "static"
      ? !1
      : this.state.isInvalidated
      ? !0
      : !W(this.state.dataUpdatedAt, t);
  }
  onFocus() {
    this.observers
      .find((e) => e.shouldFetchOnWindowFocus())
      ?.refetch({ cancelRefetch: !1 }),
      this.#r?.continue();
  }
  onOnline() {
    this.observers
      .find((e) => e.shouldFetchOnReconnect())
      ?.refetch({ cancelRefetch: !1 }),
      this.#r?.continue();
  }
  addObserver(t) {
    this.observers.includes(t) ||
      (this.observers.push(t),
      this.clearGcTimeout(),
      this.#s.notify({ type: "observerAdded", query: this, observer: t }));
  }
  removeObserver(t) {
    this.observers.includes(t) &&
      ((this.observers = this.observers.filter((e) => e !== t)),
      this.observers.length ||
        (this.#r &&
          (this.#o ? this.#r.cancel({ revert: !0 }) : this.#r.cancelRetry()),
        this.scheduleGc()),
      this.#s.notify({ type: "observerRemoved", query: this, observer: t }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || this.#a({ type: "invalidate" });
  }
  async fetch(t, e) {
    if (this.state.fetchStatus !== "idle" && this.#r?.status() !== "rejected") {
      if (this.state.data !== void 0 && e?.cancelRefetch)
        this.cancel({ silent: !0 });
      else if (this.#r) return this.#r.continueRetry(), this.#r.promise;
    }
    if ((t && this.setOptions(t), !this.options.queryFn)) {
      let a = this.observers.find((u) => u.options.queryFn);
      a && this.setOptions(a.options);
    }
    let s = new AbortController(),
      r = (a) => {
        Object.defineProperty(a, "signal", {
          enumerable: !0,
          get: () => ((this.#o = !0), s.signal),
        });
      },
      i = () => {
        let a = Y(this.options, e),
          l = (() => {
            let o = {
              client: this.#i,
              queryKey: this.queryKey,
              meta: this.meta,
            };
            return r(o), o;
          })();
        return (
          (this.#o = !1),
          this.options.persister ? this.options.persister(a, l, this) : a(l)
        );
      },
      h = (() => {
        let a = {
          fetchOptions: e,
          options: this.options,
          queryKey: this.queryKey,
          client: this.#i,
          state: this.state,
          fetchFn: i,
        };
        return r(a), a;
      })();
    this.options.behavior?.onFetch(h, this),
      (this.#t = this.state),
      (this.state.fetchStatus === "idle" ||
        this.state.fetchMeta !== h.fetchOptions?.meta) &&
        this.#a({ type: "fetch", meta: h.fetchOptions?.meta }),
      (this.#r = tt({
        initialPromise: e?.initialPromise,
        fn: h.fetchFn,
        onCancel: (a) => {
          a instanceof K &&
            a.revert &&
            this.setState({ ...this.#t, fetchStatus: "idle" }),
            s.abort();
        },
        onFail: (a, u) => {
          this.#a({ type: "failed", failureCount: a, error: u });
        },
        onPause: () => {
          this.#a({ type: "pause" });
        },
        onContinue: () => {
          this.#a({ type: "continue" });
        },
        retry: h.options.retry,
        retryDelay: h.options.retryDelay,
        networkMode: h.options.networkMode,
        canRun: () => !0,
      }));
    try {
      let a = await this.#r.start();
      if (a === void 0) throw new Error(`${this.queryHash} data is undefined`);
      return (
        this.setData(a),
        this.#s.config.onSuccess?.(a, this),
        this.#s.config.onSettled?.(a, this.state.error, this),
        a
      );
    } catch (a) {
      if (a instanceof K) {
        if (a.silent) return this.#r.promise;
        if (a.revert) {
          if (this.state.data === void 0) throw a;
          return this.state.data;
        }
      }
      throw (
        (this.#a({ type: "error", error: a }),
        this.#s.config.onError?.(a, this),
        this.#s.config.onSettled?.(this.state.data, a, this),
        a)
      );
    } finally {
      this.scheduleGc();
    }
  }
  #a(t) {
    let e = (s) => {
      switch (t.type) {
        case "failed":
          return {
            ...s,
            fetchFailureCount: t.failureCount,
            fetchFailureReason: t.error,
          };
        case "pause":
          return { ...s, fetchStatus: "paused" };
        case "continue":
          return { ...s, fetchStatus: "fetching" };
        case "fetch":
          return {
            ...s,
            ...at(s.data, this.options),
            fetchMeta: t.meta ?? null,
          };
        case "success":
          let r = {
            ...s,
            ...Mt(t.data, t.dataUpdatedAt),
            dataUpdateCount: s.dataUpdateCount + 1,
            ...(!t.manual && {
              fetchStatus: "idle",
              fetchFailureCount: 0,
              fetchFailureReason: null,
            }),
          };
          return (this.#t = t.manual ? r : void 0), r;
        case "error":
          let i = t.error;
          return {
            ...s,
            error: i,
            errorUpdateCount: s.errorUpdateCount + 1,
            errorUpdatedAt: Date.now(),
            fetchFailureCount: s.fetchFailureCount + 1,
            fetchFailureReason: i,
            fetchStatus: "idle",
            status: "error",
          };
        case "invalidate":
          return { ...s, isInvalidated: !0 };
        case "setState":
          return { ...s, ...t.state };
      }
    };
    (this.state = e(this.state)),
      d.batch(() => {
        this.observers.forEach((s) => {
          s.onQueryUpdate();
        }),
          this.#s.notify({ query: this, type: "updated", action: t });
      });
  }
};
function at(t, e) {
  return {
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchStatus: it(e.networkMode) ? "fetching" : "paused",
    ...(t === void 0 && { error: null, status: "pending" }),
  };
}
function Mt(t, e) {
  return {
    data: t,
    dataUpdatedAt: e ?? Date.now(),
    error: null,
    isInvalidated: !1,
    status: "success",
  };
}
function Rt(t) {
  let e = typeof t.initialData == "function" ? t.initialData() : t.initialData,
    s = e !== void 0,
    r = s
      ? typeof t.initialDataUpdatedAt == "function"
        ? t.initialDataUpdatedAt()
        : t.initialDataUpdatedAt
      : 0;
  return {
    data: e,
    dataUpdateCount: 0,
    dataUpdatedAt: s ? r ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: s ? "success" : "pending",
    fetchStatus: "idle",
  };
}
var V = class extends O {
  constructor(t, e) {
    super(),
      (this.options = e),
      (this.#e = t),
      (this.#a = null),
      (this.#o = G()),
      this.bindMethods(),
      this.setOptions(e);
  }
  #e;
  #t = void 0;
  #s = void 0;
  #i = void 0;
  #r;
  #n;
  #o;
  #a;
  #d;
  #l;
  #f;
  #h;
  #c;
  #u;
  #y = new Set();
  bindMethods() {
    this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.size === 1 &&
      (this.#t.addObserver(this),
      Qt(this.#t, this.options) ? this.#p() : this.updateResult(),
      this.#b());
  }
  onUnsubscribe() {
    this.hasListeners() || this.destroy();
  }
  shouldFetchOnReconnect() {
    return ot(this.#t, this.options, this.options.refetchOnReconnect);
  }
  shouldFetchOnWindowFocus() {
    return ot(this.#t, this.options, this.options.refetchOnWindowFocus);
  }
  destroy() {
    (this.listeners = new Set()),
      this.#O(),
      this.#S(),
      this.#t.removeObserver(this);
  }
  setOptions(t) {
    let e = this.options,
      s = this.#t;
    if (
      ((this.options = this.#e.defaultQueryOptions(t)),
      this.options.enabled !== void 0 &&
        typeof this.options.enabled != "boolean" &&
        typeof this.options.enabled != "function" &&
        typeof S(this.options.enabled, this.#t) != "boolean")
    )
      throw new Error(
        "Expected enabled to be a boolean or a callback that returns a boolean"
      );
    this.#P(),
      this.#t.setOptions(this.options),
      e._defaulted &&
        !x(this.options, e) &&
        this.#e
          .getQueryCache()
          .notify({
            type: "observerOptionsUpdated",
            query: this.#t,
            observer: this,
          });
    let r = this.hasListeners();
    r && Et(this.#t, s, this.options, e) && this.#p(),
      this.updateResult(),
      r &&
        (this.#t !== s ||
          S(this.options.enabled, this.#t) !== S(e.enabled, this.#t) ||
          Q(this.options.staleTime, this.#t) !== Q(e.staleTime, this.#t)) &&
        this.#m();
    let i = this.#v();
    r &&
      (this.#t !== s ||
        S(this.options.enabled, this.#t) !== S(e.enabled, this.#t) ||
        i !== this.#u) &&
      this.#g(i);
  }
  getOptimisticResult(t) {
    let e = this.#e.getQueryCache().build(this.#e, t),
      s = this.createResult(e, t);
    return (
      Wt(this, s) &&
        ((this.#i = s), (this.#n = this.options), (this.#r = this.#t.state)),
      s
    );
  }
  getCurrentResult() {
    return this.#i;
  }
  trackResult(t, e) {
    return new Proxy(t, {
      get: (s, r) => (
        this.trackProp(r),
        e?.(r),
        r === "promise" &&
          (this.trackProp("data"),
          !this.options.experimental_prefetchInRender &&
            this.#o.status === "pending" &&
            this.#o.reject(
              new Error(
                "experimental_prefetchInRender feature flag is not enabled"
              )
            )),
        Reflect.get(s, r)
      ),
    });
  }
  trackProp(t) {
    this.#y.add(t);
  }
  getCurrentQuery() {
    return this.#t;
  }
  refetch({ ...t } = {}) {
    return this.fetch({ ...t });
  }
  fetchOptimistic(t) {
    let e = this.#e.defaultQueryOptions(t),
      s = this.#e.getQueryCache().build(this.#e, e);
    return s.fetch().then(() => this.createResult(s, e));
  }
  fetch(t) {
    return this.#p({ ...t, cancelRefetch: t.cancelRefetch ?? !0 }).then(
      () => (this.updateResult(), this.#i)
    );
  }
  #p(t) {
    this.#P();
    let e = this.#t.fetch(this.options, t);
    return t?.throwOnError || (e = e.catch(m)), e;
  }
  #m() {
    this.#O();
    let t = Q(this.options.staleTime, this.#t);
    if (C || this.#i.isStale || !L(t)) return;
    let s = W(this.#i.dataUpdatedAt, t) + 1;
    this.#h = R.setTimeout(() => {
      this.#i.isStale || this.updateResult();
    }, s);
  }
  #v() {
    return (
      (typeof this.options.refetchInterval == "function"
        ? this.options.refetchInterval(this.#t)
        : this.options.refetchInterval) ?? !1
    );
  }
  #g(t) {
    this.#S(),
      (this.#u = t),
      !(
        C ||
        S(this.options.enabled, this.#t) === !1 ||
        !L(this.#u) ||
        this.#u === 0
      ) &&
        (this.#c = R.setInterval(() => {
          (this.options.refetchIntervalInBackground || A.isFocused()) &&
            this.#p();
        }, this.#u));
  }
  #b() {
    this.#m(), this.#g(this.#v());
  }
  #O() {
    this.#h && (R.clearTimeout(this.#h), (this.#h = void 0));
  }
  #S() {
    this.#c && (R.clearInterval(this.#c), (this.#c = void 0));
  }
  createResult(t, e) {
    let s = this.#t,
      r = this.options,
      i = this.#i,
      n = this.#r,
      h = this.#n,
      u = t !== s ? t.state : this.#s,
      { state: l } = t,
      o = { ...l },
      p = !1,
      c;
    if (e._optimisticResults) {
      let w = this.hasListeners(),
        B = !w && Qt(t, e),
        k = w && Et(t, s, e, r);
      (B || k) && (o = { ...o, ...at(l.data, t.options) }),
        e._optimisticResults === "isRestoring" && (o.fetchStatus = "idle");
    }
    let { error: b, errorUpdatedAt: v, status: f } = o;
    c = o.data;
    let g = !1;
    if (e.placeholderData !== void 0 && c === void 0 && f === "pending") {
      let w;
      i?.isPlaceholderData && e.placeholderData === h?.placeholderData
        ? ((w = i.data), (g = !0))
        : (w =
            typeof e.placeholderData == "function"
              ? e.placeholderData(this.#f?.state.data, this.#f)
              : e.placeholderData),
        w !== void 0 && ((f = "success"), (c = z(i?.data, w, e)), (p = !0));
    }
    if (e.select && c !== void 0 && !g)
      if (i && c === n?.data && e.select === this.#d) c = this.#l;
      else
        try {
          (this.#d = e.select),
            (c = e.select(c)),
            (c = z(i?.data, c, e)),
            (this.#l = c),
            (this.#a = null);
        } catch (w) {
          this.#a = w;
        }
    this.#a && ((b = this.#a), (c = this.#l), (v = Date.now()), (f = "error"));
    let y = o.fetchStatus === "fetching",
      P = f === "pending",
      M = f === "error",
      F = P && y,
      T = c !== void 0,
      E = {
        status: f,
        fetchStatus: o.fetchStatus,
        isPending: P,
        isSuccess: f === "success",
        isError: M,
        isInitialLoading: F,
        isLoading: F,
        data: c,
        dataUpdatedAt: o.dataUpdatedAt,
        error: b,
        errorUpdatedAt: v,
        failureCount: o.fetchFailureCount,
        failureReason: o.fetchFailureReason,
        errorUpdateCount: o.errorUpdateCount,
        isFetched: o.dataUpdateCount > 0 || o.errorUpdateCount > 0,
        isFetchedAfterMount:
          o.dataUpdateCount > u.dataUpdateCount ||
          o.errorUpdateCount > u.errorUpdateCount,
        isFetching: y,
        isRefetching: y && !P,
        isLoadingError: M && !T,
        isPaused: o.fetchStatus === "paused",
        isPlaceholderData: p,
        isRefetchError: M && T,
        isStale: ut(t, e),
        refetch: this.refetch,
        promise: this.#o,
        isEnabled: S(e.enabled, t) !== !1,
      };
    if (this.options.experimental_prefetchInRender) {
      let w = ($) => {
          E.status === "error"
            ? $.reject(E.error)
            : E.data !== void 0 && $.resolve(E.data);
        },
        B = () => {
          let $ = (this.#o = E.promise = G());
          w($);
        },
        k = this.#o;
      switch (k.status) {
        case "pending":
          t.queryHash === s.queryHash && w(k);
          break;
        case "fulfilled":
          (E.status === "error" || E.data !== k.value) && B();
          break;
        case "rejected":
          (E.status !== "error" || E.error !== k.reason) && B();
          break;
      }
    }
    return E;
  }
  updateResult() {
    let t = this.#i,
      e = this.createResult(this.#t, this.options);
    if (
      ((this.#r = this.#t.state),
      (this.#n = this.options),
      this.#r.data !== void 0 && (this.#f = this.#t),
      x(e, t))
    )
      return;
    this.#i = e;
    let s = () => {
      if (!t) return !0;
      let { notifyOnChangeProps: r } = this.options,
        i = typeof r == "function" ? r() : r;
      if (i === "all" || (!i && !this.#y.size)) return !0;
      let n = new Set(i ?? this.#y);
      return (
        this.options.throwOnError && n.add("error"),
        Object.keys(this.#i).some((h) => {
          let a = h;
          return this.#i[a] !== t[a] && n.has(a);
        })
      );
    };
    this.#w({ listeners: s() });
  }
  #P() {
    let t = this.#e.getQueryCache().build(this.#e, this.options);
    if (t === this.#t) return;
    let e = this.#t;
    (this.#t = t),
      (this.#s = t.state),
      this.hasListeners() && (e?.removeObserver(this), t.addObserver(this));
  }
  onQueryUpdate() {
    this.updateResult(), this.hasListeners() && this.#b();
  }
  #w(t) {
    d.batch(() => {
      t.listeners &&
        this.listeners.forEach((e) => {
          e(this.#i);
        }),
        this.#e
          .getQueryCache()
          .notify({ query: this.#t, type: "observerResultsUpdated" });
    });
  }
};
function $t(t, e) {
  return (
    S(e.enabled, t) !== !1 &&
    t.state.data === void 0 &&
    !(t.state.status === "error" && e.retryOnMount === !1)
  );
}
function Qt(t, e) {
  return $t(t, e) || (t.state.data !== void 0 && ot(t, e, e.refetchOnMount));
}
function ot(t, e, s) {
  if (S(e.enabled, t) !== !1 && Q(e.staleTime, t) !== "static") {
    let r = typeof s == "function" ? s(t) : s;
    return r === "always" || (r !== !1 && ut(t, e));
  }
  return !1;
}
function Et(t, e, s, r) {
  return (
    (t !== e || S(r.enabled, t) === !1) &&
    (!s.suspense || t.state.status !== "error") &&
    ut(t, s)
  );
}
function ut(t, e) {
  return S(e.enabled, t) !== !1 && t.isStaleByTime(Q(e.staleTime, t));
}
function Wt(t, e) {
  return !x(t.getCurrentResult(), e);
}
function j(t) {
  return {
    onFetch: (e, s) => {
      let r = e.options,
        i = e.fetchOptions?.meta?.fetchMore?.direction,
        n = e.state.data?.pages || [],
        h = e.state.data?.pageParams || [],
        a = { pages: [], pageParams: [] },
        u = 0,
        l = async () => {
          let o = !1,
            p = (v) => {
              Object.defineProperty(v, "signal", {
                enumerable: !0,
                get: () => (
                  e.signal.aborted
                    ? (o = !0)
                    : e.signal.addEventListener("abort", () => {
                        o = !0;
                      }),
                  e.signal
                ),
              });
            },
            c = Y(e.options, e.fetchOptions),
            b = async (v, f, g) => {
              if (o) return Promise.reject();
              if (f == null && v.pages.length) return Promise.resolve(v);
              let P = (() => {
                  let N = {
                    client: e.client,
                    queryKey: e.queryKey,
                    pageParam: f,
                    direction: g ? "backward" : "forward",
                    meta: e.options.meta,
                  };
                  return p(N), N;
                })(),
                M = await c(P),
                { maxPages: F } = e.options,
                T = g ? bt : X;
              return {
                pages: T(v.pages, M, F),
                pageParams: T(v.pageParams, f, F),
              };
            };
          if (i && n.length) {
            let v = i === "backward",
              f = v ? Dt : ht,
              g = { pages: n, pageParams: h },
              y = f(r, g);
            a = await b(g, y, v);
          } else {
            let v = t ?? n.length;
            do {
              let f = u === 0 ? h[0] ?? r.initialPageParam : ht(r, a);
              if (u > 0 && f == null) break;
              (a = await b(a, f)), u++;
            } while (u < v);
          }
          return a;
        };
      e.options.persister
        ? (e.fetchFn = () =>
            e.options.persister?.(
              l,
              {
                client: e.client,
                queryKey: e.queryKey,
                meta: e.options.meta,
                signal: e.signal,
              },
              s
            ))
        : (e.fetchFn = l);
    },
  };
}
function ht(t, { pages: e, pageParams: s }) {
  let r = e.length - 1;
  return e.length > 0 ? t.getNextPageParam(e[r], e, s[r], s) : void 0;
}
function Dt(t, { pages: e, pageParams: s }) {
  return e.length > 0 ? t.getPreviousPageParam?.(e[0], e, s[0], s) : void 0;
}
function Ft(t, e) {
  return e ? ht(t, e) != null : !1;
}
function Tt(t, e) {
  return !e || !t.getPreviousPageParam ? !1 : Dt(t, e) != null;
}
var Jt = class extends V {
  constructor(t, e) {
    super(t, e);
  }
  bindMethods() {
    super.bindMethods(),
      (this.fetchNextPage = this.fetchNextPage.bind(this)),
      (this.fetchPreviousPage = this.fetchPreviousPage.bind(this));
  }
  setOptions(t) {
    super.setOptions({ ...t, behavior: j() });
  }
  getOptimisticResult(t) {
    return (t.behavior = j()), super.getOptimisticResult(t);
  }
  fetchNextPage(t) {
    return this.fetch({ ...t, meta: { fetchMore: { direction: "forward" } } });
  }
  fetchPreviousPage(t) {
    return this.fetch({ ...t, meta: { fetchMore: { direction: "backward" } } });
  }
  createResult(t, e) {
    let { state: s } = t,
      r = super.createResult(t, e),
      { isFetching: i, isRefetching: n, isError: h, isRefetchError: a } = r,
      u = s.fetchMeta?.fetchMore?.direction,
      l = h && u === "forward",
      o = i && u === "forward",
      p = h && u === "backward",
      c = i && u === "backward";
    return {
      ...r,
      fetchNextPage: this.fetchNextPage,
      fetchPreviousPage: this.fetchPreviousPage,
      hasNextPage: Ft(e, s.data),
      hasPreviousPage: Tt(e, s.data),
      isFetchNextPageError: l,
      isFetchingNextPage: o,
      isFetchPreviousPageError: p,
      isFetchingPreviousPage: c,
      isRefetchError: a && !l && !p,
      isRefetching: n && !o && !c,
    };
  }
};
var ct = class extends et {
  #e;
  #t;
  #s;
  #i;
  constructor(t) {
    super(),
      (this.#e = t.client),
      (this.mutationId = t.mutationId),
      (this.#s = t.mutationCache),
      (this.#t = []),
      (this.state = t.state || lt()),
      this.setOptions(t.options),
      this.scheduleGc();
  }
  setOptions(t) {
    (this.options = t), this.updateGcTime(this.options.gcTime);
  }
  get meta() {
    return this.options.meta;
  }
  addObserver(t) {
    this.#t.includes(t) ||
      (this.#t.push(t),
      this.clearGcTimeout(),
      this.#s.notify({ type: "observerAdded", mutation: this, observer: t }));
  }
  removeObserver(t) {
    (this.#t = this.#t.filter((e) => e !== t)),
      this.scheduleGc(),
      this.#s.notify({ type: "observerRemoved", mutation: this, observer: t });
  }
  optionalRemove() {
    this.#t.length ||
      (this.state.status === "pending"
        ? this.scheduleGc()
        : this.#s.remove(this));
  }
  continue() {
    return this.#i?.continue() ?? this.execute(this.state.variables);
  }
  async execute(t) {
    let e = () => {
        this.#r({ type: "continue" });
      },
      s = {
        client: this.#e,
        meta: this.options.meta,
        mutationKey: this.options.mutationKey,
      };
    this.#i = tt({
      fn: () =>
        this.options.mutationFn
          ? this.options.mutationFn(t, s)
          : Promise.reject(new Error("No mutationFn found")),
      onFail: (n, h) => {
        this.#r({ type: "failed", failureCount: n, error: h });
      },
      onPause: () => {
        this.#r({ type: "pause" });
      },
      onContinue: e,
      retry: this.options.retry ?? 0,
      retryDelay: this.options.retryDelay,
      networkMode: this.options.networkMode,
      canRun: () => this.#s.canRun(this),
    });
    let r = this.state.status === "pending",
      i = !this.#i.canStart();
    try {
      if (r) e();
      else {
        this.#r({ type: "pending", variables: t, isPaused: i }),
          await this.#s.config.onMutate?.(t, this, s);
        let h = await this.options.onMutate?.(t, s);
        h !== this.state.context &&
          this.#r({ type: "pending", context: h, variables: t, isPaused: i });
      }
      let n = await this.#i.start();
      return (
        await this.#s.config.onSuccess?.(n, t, this.state.context, this, s),
        await this.options.onSuccess?.(n, t, this.state.context, s),
        await this.#s.config.onSettled?.(
          n,
          null,
          this.state.variables,
          this.state.context,
          this,
          s
        ),
        await this.options.onSettled?.(n, null, t, this.state.context, s),
        this.#r({ type: "success", data: n }),
        n
      );
    } catch (n) {
      try {
        throw (
          (await this.#s.config.onError?.(n, t, this.state.context, this, s),
          await this.options.onError?.(n, t, this.state.context, s),
          await this.#s.config.onSettled?.(
            void 0,
            n,
            this.state.variables,
            this.state.context,
            this,
            s
          ),
          await this.options.onSettled?.(void 0, n, t, this.state.context, s),
          n)
        );
      } finally {
        this.#r({ type: "error", error: n });
      }
    } finally {
      this.#s.runNext(this);
    }
  }
  #r(t) {
    let e = (s) => {
      switch (t.type) {
        case "failed":
          return { ...s, failureCount: t.failureCount, failureReason: t.error };
        case "pause":
          return { ...s, isPaused: !0 };
        case "continue":
          return { ...s, isPaused: !1 };
        case "pending":
          return {
            ...s,
            context: t.context,
            data: void 0,
            failureCount: 0,
            failureReason: null,
            error: null,
            isPaused: t.isPaused,
            status: "pending",
            variables: t.variables,
            submittedAt: Date.now(),
          };
        case "success":
          return {
            ...s,
            data: t.data,
            failureCount: 0,
            failureReason: null,
            error: null,
            status: "success",
            isPaused: !1,
          };
        case "error":
          return {
            ...s,
            data: void 0,
            error: t.error,
            failureCount: s.failureCount + 1,
            failureReason: t.error,
            isPaused: !1,
            status: "error",
          };
      }
    };
    (this.state = e(this.state)),
      d.batch(() => {
        this.#t.forEach((s) => {
          s.onMutationUpdate(t);
        }),
          this.#s.notify({ mutation: this, type: "updated", action: t });
      });
  }
};
function lt() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0,
    submittedAt: 0,
  };
}
var ft = class extends O {
  constructor(t = {}) {
    super(),
      (this.config = t),
      (this.#e = new Set()),
      (this.#t = new Map()),
      (this.#s = 0);
  }
  #e;
  #t;
  #s;
  build(t, e, s) {
    let r = new ct({
      client: t,
      mutationCache: this,
      mutationId: ++this.#s,
      options: t.defaultMutationOptions(e),
      state: s,
    });
    return this.add(r), r;
  }
  add(t) {
    this.#e.add(t);
    let e = st(t);
    if (typeof e == "string") {
      let s = this.#t.get(e);
      s ? s.push(t) : this.#t.set(e, [t]);
    }
    this.notify({ type: "added", mutation: t });
  }
  remove(t) {
    if (this.#e.delete(t)) {
      let e = st(t);
      if (typeof e == "string") {
        let s = this.#t.get(e);
        if (s)
          if (s.length > 1) {
            let r = s.indexOf(t);
            r !== -1 && s.splice(r, 1);
          } else s[0] === t && this.#t.delete(e);
      }
    }
    this.notify({ type: "removed", mutation: t });
  }
  canRun(t) {
    let e = st(t);
    if (typeof e == "string") {
      let r = this.#t.get(e)?.find((i) => i.state.status === "pending");
      return !r || r === t;
    } else return !0;
  }
  runNext(t) {
    let e = st(t);
    return typeof e == "string"
      ? this.#t
          .get(e)
          ?.find((r) => r !== t && r.state.isPaused)
          ?.continue() ?? Promise.resolve()
      : Promise.resolve();
  }
  clear() {
    d.batch(() => {
      this.#e.forEach((t) => {
        this.notify({ type: "removed", mutation: t });
      }),
        this.#e.clear(),
        this.#t.clear();
    });
  }
  getAll() {
    return Array.from(this.#e);
  }
  find(t) {
    let e = { exact: !0, ...t };
    return this.getAll().find((s) => Z(e, s));
  }
  findAll(t = {}) {
    return this.getAll().filter((e) => Z(t, e));
  }
  notify(t) {
    d.batch(() => {
      this.listeners.forEach((e) => {
        e(t);
      });
    });
  }
  resumePausedMutations() {
    let t = this.getAll().filter((e) => e.state.isPaused);
    return d.batch(() => Promise.all(t.map((e) => e.continue().catch(m))));
  }
};
function st(t) {
  return t.options.scope?.id;
}
var Zt = class extends O {
  #e;
  #t = void 0;
  #s;
  #i;
  constructor(t, e) {
    super(), (this.#e = t), this.setOptions(e), this.bindMethods(), this.#r();
  }
  bindMethods() {
    (this.mutate = this.mutate.bind(this)),
      (this.reset = this.reset.bind(this));
  }
  setOptions(t) {
    let e = this.options;
    (this.options = this.#e.defaultMutationOptions(t)),
      x(this.options, e) ||
        this.#e
          .getMutationCache()
          .notify({
            type: "observerOptionsUpdated",
            mutation: this.#s,
            observer: this,
          }),
      e?.mutationKey &&
      this.options.mutationKey &&
      D(e.mutationKey) !== D(this.options.mutationKey)
        ? this.reset()
        : this.#s?.state.status === "pending" &&
          this.#s.setOptions(this.options);
  }
  onUnsubscribe() {
    this.hasListeners() || this.#s?.removeObserver(this);
  }
  onMutationUpdate(t) {
    this.#r(), this.#n(t);
  }
  getCurrentResult() {
    return this.#t;
  }
  reset() {
    this.#s?.removeObserver(this), (this.#s = void 0), this.#r(), this.#n();
  }
  mutate(t, e) {
    return (
      (this.#i = e),
      this.#s?.removeObserver(this),
      (this.#s = this.#e.getMutationCache().build(this.#e, this.options)),
      this.#s.addObserver(this),
      this.#s.execute(t)
    );
  }
  #r() {
    let t = this.#s?.state ?? lt();
    this.#t = {
      ...t,
      isPending: t.status === "pending",
      isSuccess: t.status === "success",
      isError: t.status === "error",
      isIdle: t.status === "idle",
      mutate: this.mutate,
      reset: this.reset,
    };
  }
  #n(t) {
    d.batch(() => {
      if (this.#i && this.hasListeners()) {
        let e = this.#t.variables,
          s = this.#t.context,
          r = {
            client: this.#e,
            meta: this.options.meta,
            mutationKey: this.options.mutationKey,
          };
        t?.type === "success"
          ? (this.#i.onSuccess?.(t.data, e, s, r),
            this.#i.onSettled?.(t.data, null, e, s, r))
          : t?.type === "error" &&
            (this.#i.onError?.(t.error, e, s, r),
            this.#i.onSettled?.(void 0, t.error, e, s, r));
      }
      this.listeners.forEach((e) => {
        e(this.#t);
      });
    });
  }
};
function xt(t, e) {
  let s = new Set(e);
  return t.filter((r) => !s.has(r));
}
function Xt(t, e, s) {
  let r = t.slice(0);
  return (r[e] = s), r;
}
var Yt = class extends O {
  #e;
  #t;
  #s;
  #i;
  #r;
  #n;
  #o;
  #a;
  #d = [];
  constructor(t, e, s) {
    super(),
      (this.#e = t),
      (this.#i = s),
      (this.#s = []),
      (this.#r = []),
      (this.#t = []),
      this.setQueries(e);
  }
  onSubscribe() {
    this.listeners.size === 1 &&
      this.#r.forEach((t) => {
        t.subscribe((e) => {
          this.#c(t, e);
        });
      });
  }
  onUnsubscribe() {
    this.listeners.size || this.destroy();
  }
  destroy() {
    (this.listeners = new Set()),
      this.#r.forEach((t) => {
        t.destroy();
      });
  }
  setQueries(t, e) {
    (this.#s = t),
      (this.#i = e),
      d.batch(() => {
        let s = this.#r,
          r = this.#h(this.#s);
        (this.#d = r),
          r.forEach((o) => o.observer.setOptions(o.defaultedQueryOptions));
        let i = r.map((o) => o.observer),
          n = i.map((o) => o.getCurrentResult()),
          h = s.length !== i.length,
          a = i.some((o, p) => o !== s[p]),
          u = h || a,
          l = u
            ? !0
            : n.some((o, p) => {
                let c = this.#t[p];
                return !c || !x(o, c);
              });
        (!u && !l) ||
          (u && (this.#r = i),
          (this.#t = n),
          this.hasListeners() &&
            (u &&
              (xt(s, i).forEach((o) => {
                o.destroy();
              }),
              xt(i, s).forEach((o) => {
                o.subscribe((p) => {
                  this.#c(o, p);
                });
              })),
            this.#u()));
      });
  }
  getCurrentResult() {
    return this.#t;
  }
  getQueries() {
    return this.#r.map((t) => t.getCurrentQuery());
  }
  getObservers() {
    return this.#r;
  }
  getOptimisticResult(t, e) {
    let s = this.#h(t),
      r = s.map((i) => i.observer.getOptimisticResult(i.defaultedQueryOptions));
    return [r, (i) => this.#f(i ?? r, e), () => this.#l(r, s)];
  }
  #l(t, e) {
    return e.map((s, r) => {
      let i = t[r];
      return s.defaultedQueryOptions.notifyOnChangeProps
        ? i
        : s.observer.trackResult(i, (n) => {
            e.forEach((h) => {
              h.observer.trackProp(n);
            });
          });
    });
  }
  #f(t, e) {
    return e
      ? ((!this.#n || this.#t !== this.#a || e !== this.#o) &&
          ((this.#o = e), (this.#a = this.#t), (this.#n = _(this.#n, e(t)))),
        this.#n)
      : t;
  }
  #h(t) {
    let e = new Map(this.#r.map((r) => [r.options.queryHash, r])),
      s = [];
    return (
      t.forEach((r) => {
        let i = this.#e.defaultQueryOptions(r),
          n = e.get(i.queryHash);
        n
          ? s.push({ defaultedQueryOptions: i, observer: n })
          : s.push({ defaultedQueryOptions: i, observer: new V(this.#e, i) });
      }),
      s
    );
  }
  #c(t, e) {
    let s = this.#r.indexOf(t);
    s !== -1 && ((this.#t = Xt(this.#t, s, e)), this.#u());
  }
  #u() {
    if (this.hasListeners()) {
      let t = this.#n,
        e = this.#l(this.#t, this.#d),
        s = this.#f(e, this.#i?.combine);
      t !== s &&
        d.batch(() => {
          this.listeners.forEach((r) => {
            r(this.#t);
          });
        });
    }
  }
};
var dt = class extends O {
  constructor(t = {}) {
    super(), (this.config = t), (this.#e = new Map());
  }
  #e;
  build(t, e, s) {
    let r = e.queryKey,
      i = e.queryHash ?? H(r, e),
      n = this.get(i);
    return (
      n ||
        ((n = new nt({
          client: t,
          queryKey: r,
          queryHash: i,
          options: t.defaultQueryOptions(e),
          state: s,
          defaultOptions: t.getQueryDefaults(r),
        })),
        this.add(n)),
      n
    );
  }
  add(t) {
    this.#e.has(t.queryHash) ||
      (this.#e.set(t.queryHash, t), this.notify({ type: "added", query: t }));
  }
  remove(t) {
    let e = this.#e.get(t.queryHash);
    e &&
      (t.destroy(),
      e === t && this.#e.delete(t.queryHash),
      this.notify({ type: "removed", query: t }));
  }
  clear() {
    d.batch(() => {
      this.getAll().forEach((t) => {
        this.remove(t);
      });
    });
  }
  get(t) {
    return this.#e.get(t);
  }
  getAll() {
    return [...this.#e.values()];
  }
  find(t) {
    let e = { exact: !0, ...t };
    return this.getAll().find((s) => J(e, s));
  }
  findAll(t = {}) {
    let e = this.getAll();
    return Object.keys(t).length > 0 ? e.filter((s) => J(t, s)) : e;
  }
  notify(t) {
    d.batch(() => {
      this.listeners.forEach((e) => {
        e(t);
      });
    });
  }
  onFocus() {
    d.batch(() => {
      this.getAll().forEach((t) => {
        t.onFocus();
      });
    });
  }
  onOnline() {
    d.batch(() => {
      this.getAll().forEach((t) => {
        t.onOnline();
      });
    });
  }
};
var te = class {
  #e;
  #t;
  #s;
  #i;
  #r;
  #n;
  #o;
  #a;
  constructor(t = {}) {
    (this.#e = t.queryCache || new dt()),
      (this.#t = t.mutationCache || new ft()),
      (this.#s = t.defaultOptions || {}),
      (this.#i = new Map()),
      (this.#r = new Map()),
      (this.#n = 0);
  }
  mount() {
    this.#n++,
      this.#n === 1 &&
        ((this.#o = A.subscribe(async (t) => {
          t && (await this.resumePausedMutations(), this.#e.onFocus());
        })),
        (this.#a = I.subscribe(async (t) => {
          t && (await this.resumePausedMutations(), this.#e.onOnline());
        })));
  }
  unmount() {
    this.#n--,
      this.#n === 0 &&
        (this.#o?.(), (this.#o = void 0), this.#a?.(), (this.#a = void 0));
  }
  isFetching(t) {
    return this.#e.findAll({ ...t, fetchStatus: "fetching" }).length;
  }
  isMutating(t) {
    return this.#t.findAll({ ...t, status: "pending" }).length;
  }
  getQueryData(t) {
    let e = this.defaultQueryOptions({ queryKey: t });
    return this.#e.get(e.queryHash)?.state.data;
  }
  ensureQueryData(t) {
    let e = this.defaultQueryOptions(t),
      s = this.#e.build(this, e),
      r = s.state.data;
    return r === void 0
      ? this.fetchQuery(t)
      : (t.revalidateIfStale &&
          s.isStaleByTime(Q(e.staleTime, s)) &&
          this.prefetchQuery(e),
        Promise.resolve(r));
  }
  getQueriesData(t) {
    return this.#e.findAll(t).map(({ queryKey: e, state: s }) => {
      let r = s.data;
      return [e, r];
    });
  }
  setQueryData(t, e, s) {
    let r = this.defaultQueryOptions({ queryKey: t }),
      n = this.#e.get(r.queryHash)?.state.data,
      h = vt(e, n);
    if (h !== void 0)
      return this.#e.build(this, r).setData(h, { ...s, manual: !0 });
  }
  setQueriesData(t, e, s) {
    return d.batch(() =>
      this.#e
        .findAll(t)
        .map(({ queryKey: r }) => [r, this.setQueryData(r, e, s)])
    );
  }
  getQueryState(t) {
    let e = this.defaultQueryOptions({ queryKey: t });
    return this.#e.get(e.queryHash)?.state;
  }
  removeQueries(t) {
    let e = this.#e;
    d.batch(() => {
      e.findAll(t).forEach((s) => {
        e.remove(s);
      });
    });
  }
  resetQueries(t, e) {
    let s = this.#e;
    return d.batch(
      () => (
        s.findAll(t).forEach((r) => {
          r.reset();
        }),
        this.refetchQueries({ type: "active", ...t }, e)
      )
    );
  }
  cancelQueries(t, e = {}) {
    let s = { revert: !0, ...e },
      r = d.batch(() => this.#e.findAll(t).map((i) => i.cancel(s)));
    return Promise.all(r).then(m).catch(m);
  }
  invalidateQueries(t, e = {}) {
    return d.batch(
      () => (
        this.#e.findAll(t).forEach((s) => {
          s.invalidate();
        }),
        t?.refetchType === "none"
          ? Promise.resolve()
          : this.refetchQueries(
              { ...t, type: t?.refetchType ?? t?.type ?? "active" },
              e
            )
      )
    );
  }
  refetchQueries(t, e = {}) {
    let s = { ...e, cancelRefetch: e.cancelRefetch ?? !0 },
      r = d.batch(() =>
        this.#e
          .findAll(t)
          .filter((i) => !i.isDisabled() && !i.isStatic())
          .map((i) => {
            let n = i.fetch(void 0, s);
            return (
              s.throwOnError || (n = n.catch(m)),
              i.state.fetchStatus === "paused" ? Promise.resolve() : n
            );
          })
      );
    return Promise.all(r).then(m);
  }
  fetchQuery(t) {
    let e = this.defaultQueryOptions(t);
    e.retry === void 0 && (e.retry = !1);
    let s = this.#e.build(this, e);
    return s.isStaleByTime(Q(e.staleTime, s))
      ? s.fetch(e)
      : Promise.resolve(s.state.data);
  }
  prefetchQuery(t) {
    return this.fetchQuery(t).then(m).catch(m);
  }
  fetchInfiniteQuery(t) {
    return (t.behavior = j(t.pages)), this.fetchQuery(t);
  }
  prefetchInfiniteQuery(t) {
    return this.fetchInfiniteQuery(t).then(m).catch(m);
  }
  ensureInfiniteQueryData(t) {
    return (t.behavior = j(t.pages)), this.ensureQueryData(t);
  }
  resumePausedMutations() {
    return I.isOnline() ? this.#t.resumePausedMutations() : Promise.resolve();
  }
  getQueryCache() {
    return this.#e;
  }
  getMutationCache() {
    return this.#t;
  }
  getDefaultOptions() {
    return this.#s;
  }
  setDefaultOptions(t) {
    this.#s = t;
  }
  setQueryDefaults(t, e) {
    this.#i.set(D(t), { queryKey: t, defaultOptions: e });
  }
  getQueryDefaults(t) {
    let e = [...this.#i.values()],
      s = {};
    return (
      e.forEach((r) => {
        q(t, r.queryKey) && Object.assign(s, r.defaultOptions);
      }),
      s
    );
  }
  setMutationDefaults(t, e) {
    this.#r.set(D(t), { mutationKey: t, defaultOptions: e });
  }
  getMutationDefaults(t) {
    let e = [...this.#r.values()],
      s = {};
    return (
      e.forEach((r) => {
        q(t, r.mutationKey) && Object.assign(s, r.defaultOptions);
      }),
      s
    );
  }
  defaultQueryOptions(t) {
    if (t._defaulted) return t;
    let e = {
      ...this.#s.queries,
      ...this.getQueryDefaults(t.queryKey),
      ...t,
      _defaulted: !0,
    };
    return (
      e.queryHash || (e.queryHash = H(e.queryKey, e)),
      e.refetchOnReconnect === void 0 &&
        (e.refetchOnReconnect = e.networkMode !== "always"),
      e.throwOnError === void 0 && (e.throwOnError = !!e.suspense),
      !e.networkMode && e.persister && (e.networkMode = "offlineFirst"),
      e.queryFn === U && (e.enabled = !1),
      e
    );
  }
  defaultMutationOptions(t) {
    return t?._defaulted
      ? t
      : {
          ...this.#s.mutations,
          ...(t?.mutationKey && this.getMutationDefaults(t.mutationKey)),
          ...t,
          _defaulted: !0,
        };
  }
  clear() {
    this.#e.clear(), this.#t.clear();
  }
};
function ee({
  streamFn: t,
  refetchMode: e = "reset",
  reducer: s = (i, n) => X(i, n),
  initialValue: r = [],
}) {
  return async (i) => {
    let n = i.client.getQueryCache().find({ queryKey: i.queryKey, exact: !0 }),
      h = !!n && n.state.data !== void 0;
    h &&
      e === "reset" &&
      n.setState({
        status: "pending",
        data: void 0,
        error: null,
        fetchStatus: "fetching",
      });
    let a = r,
      u = await t(i);
    for await (let l of u) {
      if (i.signal.aborted) break;
      (!h || e !== "replace") &&
        i.client.setQueryData(i.queryKey, (o) => s(o === void 0 ? r : o, l)),
        (a = s(a, l));
    }
    return (
      h &&
        e === "replace" &&
        !i.signal.aborted &&
        i.client.setQueryData(i.queryKey, a),
      i.client.getQueryData(i.queryKey) ?? r
    );
  };
}
var Ns = Symbol("dataTagSymbol"),
  Ls = Symbol("dataTagErrorSymbol"),
  Hs = Symbol("unsetMarker");
export {
  K as CancelledError,
  Jt as InfiniteQueryObserver,
  ct as Mutation,
  ft as MutationCache,
  Zt as MutationObserver,
  Yt as QueriesObserver,
  nt as Query,
  dt as QueryCache,
  te as QueryClient,
  V as QueryObserver,
  Ls as dataTagErrorSymbol,
  Ns as dataTagSymbol,
  Ct as defaultScheduler,
  Pt as defaultShouldDehydrateMutation,
  wt as defaultShouldDehydrateQuery,
  Ht as dehydrate,
  ee as experimental_streamedQuery,
  A as focusManager,
  D as hashKey,
  _t as hydrate,
  Bt as isCancelledError,
  C as isServer,
  kt as keepPreviousData,
  Z as matchMutation,
  J as matchQuery,
  m as noop,
  d as notifyManager,
  I as onlineManager,
  q as partialMatchKey,
  _ as replaceEqualDeep,
  Ut as shouldThrowError,
  U as skipToken,
  R as timeoutManager,
  Hs as unsetMarker,
};
//# sourceMappingURL=query-core.mjs.map
